export default __webpack_public_path__ + "static/media/qrprovider.0d5eda46.yaml";